import { Button as AntdButton } from "@mijadesign/web";
import type { ButtonProps as AntdButtonProps } from "@mijadesign/web";

interface ButtonWrapperProps extends AntdButtonProps {
  /** 子元素 */
  children?: React.ReactNode;
}

function ButtonWrapper({ children, ...props }: ButtonWrapperProps) {
  return (
    <AntdButton {...props}>
      {children}
    </AntdButton>
  );
}

export default ButtonWrapper;
